module.exports = "/_next/static/images/business-planning-service-1-bc3885a8da5146f7880ea3fbc7f48352.webp";